import type { PropsWithChildren } from 'react';
import { useStoreState } from '../store';
import { NewVersionAvailableModal } from './components/NewVersionAvailableModal';
import { useLayoutStyles } from './styles';
import { titleFromSlug } from './utils';
import { HeaderBar } from './components/HeaderBar';
import classNames from 'classnames';
import { CommonLayout } from './CommonLayout';

export const BaseLayout = ({ children, flexibleWidth = false }: PropsWithChildren<{ flexibleWidth?: boolean }>) => {
  const classes = useLayoutStyles();

  const title = useStoreState((state) => state.navigation.pageTitle) || titleFromSlug();
  const pageLoading = useStoreState((state) => state.loading.pageLoading === true);
  const partnerName = useStoreState((state) => state.session.user?.sessionPartnerName);
  const isNavigationHidden = useStoreState((state) => state.navigation.isNavigationHidden);

  return (
    <CommonLayout
      flexibleWidth={flexibleWidth}
      title={title}
      pageLoading={pageLoading}
      header={
        <HeaderBar>
          <span className={classNames(classes.partnerName, { [classes.hidden]: isNavigationHidden })}>
            {title} | {partnerName}
          </span>
        </HeaderBar>
      }
    >
      {children}
      <NewVersionAvailableModal />
    </CommonLayout>
  );
};
